import './ButtonAiChat.css';
import useShiftKey from '../../hook/useShiftKey';
import { useAiChatPanelContext } from '../../contexts/AiChatPanelContext';

function ButtonAiChat() {
    const { changeShiftKey, shiftKey } = useShiftKey();
    const { toggle } = useAiChatPanelContext();

    const onClick = () => {
        shiftKey ? changeShiftKey() : null;
        toggle();
    }

    return <div className="ai_chat" onClick={onClick}></div>
}

export default ButtonAiChat;
